import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
//import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';
//import 'stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css';

export default class ContratoManage extends Base {
             
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            controllerName: 'contratomanage',
            data: null,
            loading: true
        }
		
    }



     componentDidMount() {
  
        this.httpPost("api/v1/contratomanage/get", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    //this.viewer = new Stimulsoft.Viewer.StiViewer(undefined, 'StiViewer', false);

                    //this.report = new Stimulsoft.Report.StiReport();
                    //this.report.licenseKey = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkcgIvwL0jnpsDqRpWg5FI5kt2G7A0tYIcUygBh1sPs7koivWV0htru4Pn2682yhdY3+9jxMCVTKcKAjiEjgJzqXgLFCpe62hxJ7/VJZ9Hq5l39md0pyydqd5Dc1fSWhCtYqC042BVmGNkukYJQN0ufCozjA/qsNxzNMyEql26oHE6wWE77pHutroj+tKfOO1skJ52cbZklqPm8OiH/9mfU4rrkLffOhDQFnIxxhzhr2BL5pDFFCZ7axXX12y/4qzn5QLPBn1AVLo3NVrSmJB2KiwGwR4RL4RsYVxGScsYoCZbwqK2YrdbPHP0t5vOiLjBQ+Oy6F4rNtDYHn7SNMpthfkYiRoOibqDkPaX+RyCany0Z+uz8bzAg0oprJEn6qpkQ56WMEppdMJ9/CBnEbTFwn1s/9s8kYsmXCvtI4iQcz+RkUWspLcBzlmj0lJXWjTKMRZz+e9PmY11Au16wOnBU3NHvRc9T/Zk0YFh439GKd/fRwQrk8nJevYU65ENdAOqiP5po7Vnhif5FCiHRpxgF";
                    //this.response = fetch('/reports/stuffs.mrt');
                    ////      //const data = await response.json();

                    ////      //this.report.loadDocument(data);
                    //this.viewer.report = this.report;

                    //this.viewer.renderHtml('report');
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });

        

       



    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/contratomanage/save", {
            id: this.getCurrentFormId(),
            contratoType: this.state.data.record.contratoType,
            //baseWages: this.state.data.record.baseWages,
            //rightHousing: this.state.data.record.rightHousing,
            //rightChildren: this.state.data.record.rightChildren,
            //baseYears: this.state.data.record.baseYears,
            //costHelp: this.state.data.record.costHelp,
            //rightTransportation: this.state.data.record.rightTransportation,
            //rightFood: this.state.data.record.rightFood,
            //rightAttraction: this.state.data.record.rightAttraction,
            //rightMarriage: this.state.data.record.rightMarriage,
            contratoDateStr: this.state.data.record.contratoDateStr,
            dateStartStr: this.state.data.record.dateStartStr,
            dateEndStr: this.state.data.record.dateEndStr,
            description: this.state.data.record.description,
            isActive: this.state.data.record.isActive,
            contratoInfos:this.state.data.record.contratoInfos

        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/companies/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setBodyValue(id, field, value) {

                for (var j = 0; j < this.state.data.record.contratoInfos.length; j++) {
                    if (this.state.data.record.contratoInfos[j].id === id) {
                        this.state.data.record.contratoInfos[j][field] = value;
                    }
        
        }
        this.setState({ data: this.state.data });
    }
    changeType(type) {
        this.state.data.record.contratoType = type;
        this.setState({ data: this.state.data });
    }
    handleChange(value) {
        //تغییرات روی تاریخ رو اینجا اعمال کنید
        this.state.data.record.dateStart = value;
        this.setState(this.state.data.record.dateStart = value);
    }
    setContratoDateStr(v) {
        let data = v.toString();
        this.state.data.record.contratoDateStr = data;
        this.setState({ data: this.state.data });
    }

    setDateStartStr(v) {
        let data = v.toString();
        this.state.data.record.dateStartStr = data;
        this.setState({ data: this.state.data });
    }
    setDateEndStr(v) {
        let data = v.toString();
        this.state.data.record.dateEndStr = data;
        this.setState({ data: this.state.data });
    }

    renderForm() {
        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <span>قرارداد جناب آقا/خانم:{this.state.data.record.personName}</span>
                                        {this.state.data.record.id > 0 && <a onClick={e => this.getPdf(e)} className="btn btn-white btn-outline-light"><em class="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>}

                                    </div>
                                </div>
                            </div>
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="base">
                                                <div className="row g-4">
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">نوع قرارداد</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" defaultValue={this.state.data.record.contratoType} onChange={e => this.changeType(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب نوع قرارداد</option>
                                                                    <option value="1">دائم</option>
                                                                    <option value="2">موقت</option>
                                                                    <option value="3">کار معین</option>
                                                                    <option value="4">موقت کارمعین</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">مزد پایه ماهیانه</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.baseWages} onChange={e => this.state.data.record.baseWages = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">حق مسکن ماهیانه</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.rightHousing} onChange={e => this.state.data.record.rightHousing = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">حق اولاد ماهیانه</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.rightChildren} onChange={e => this.state.data.record.rightChildren = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">پایه سنوات</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.baseYears} onChange={e => this.state.data.record.baseYears = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">کمک هزینه اقلام مصرفی خانوار(بن کارگری)</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.costHelp} onChange={e => this.state.data.record.costHelp = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">حق ایاب ذهاب ماهیانه</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.rightTransportation} onChange={e => this.state.data.record.rightTransportation = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">حق غذا</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.rightFood} onChange={e => this.state.data.record.rightFood = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">حق جذب سرپرستی</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.rightAttraction} onChange={e => this.state.data.record.rightAttraction = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="col-lg-2">*/}
                                                    {/*    <div className="form-group">*/}
                                                    {/*        <label className="form-label">حق تاهل</label>*/}
                                                    {/*        <div className="form-control-wrap">*/}
                                                    {/*            <input className="form-control ltr" type="text" defaultValue={this.state.data.record.rightMarriage} onChange={e => this.state.data.record.rightMarriage = e.target.value} />*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ شروع همکاری</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"
                                                                    value={this.state.data.record.dateStartStr}

                                                                    style={{

                                                                        height: "34px",

                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setDateStartStr(e)}
                                                                    mobileLabels={{
                                                                        OK: "Accept",
                                                                        CANCEL: "Close",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                                {/*<input className="form-control"  type="text" defaultValue={this.state.data.record.dateStart} onChange={e => this.state.data.record.dateStart = e.target.value} />*/}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ پایان همکاری</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"
                                                                    value={this.state.data.record.dateEndStr}

                                                                    style={{

                                                                        height: "34px",

                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setDateEndStr(e)}
                                                                    mobileLabels={{
                                                                        OK: "Accept",
                                                                        CANCEL: "Close",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                                {/*<input className="form-control"  type="text" defaultValue={this.state.data.record.dateStart} onChange={e => this.state.data.record.dateStart = e.target.value} />*/}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ قرارداد</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"
                                                                    value={this.state.data.record.contratoDateStr}

                                                                    style={{

                                                                        height: "34px",

                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setContratoDateStr(e)}
                                                                    mobileLabels={{
                                                                        OK: "Accept",
                                                                        CANCEL: "Close",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                                {/*<input className="form-control"  type="text" defaultValue={this.state.data.record.dateStart} onChange={e => this.state.data.record.dateStart = e.target.value} />*/}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.data.record.contratoInfos.map((record, index) =>
                                                        <div className="col-lg-2">
                                                            <div className="form-group">
                                                                <label className="form-label">{record.title }</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control" type="text" defaultValue={record.stringValue} onChange={e => this.setBodyValue(record.id, 'stringValue',e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    
                                                    )}

                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">توضیحات</label>
                                                            <div className="form-control-wrap">
                                                                <textarea className="form-control" type="text" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <div className="custom-control custom-switch">
                                                                <input type="checkbox" className="custom-control-input" defaultChecked={this.state.data.record.isActive} onChange={e => this.state.data.record.isActive = e.target.checked} id="customSwitch2" />
                                                                <label className="custom-control-label" htmlFor="customSwitch2"> قراداد فعال </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ثبت</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
    SetCheckedInInsu(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inInsu = this.state.data.record.inInsu.replace(f, "");
        if (v) this.state.data.record.inInsu += f;
    }
    IsCheckedInsu(f) {
        f = "[" + f + "]";
        return this.state.data.record.inInsu.includes(f);
    }
    SetCheckedInTax(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inTax = this.state.data.record.inTax.replace(f, "");
        if (v) this.state.data.record.inTax += f;
    }
    IsCheckedInTax(f) {
        f = "[" + f + "]";
        return this.state.data.record.inTax.includes(f);
    }
    SetCheckedInReward(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inReward = this.state.data.record.inReward.replace(f, "");
        if (v) this.state.data.record.inReward += f;
    }
    IsCheckedInReward(f) {
        f = "[" + f + "]";
        return this.state.data.record.inReward.includes(f);
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}